// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FilmIconSignature {
  Element: SVGSVGElement;
}

export const FilmIcon: TOC<FilmIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 3V5H4V3H2V21H4V19H20V21H22V3H20ZM4 17V7H20V17H4ZM15 12L10 15V9L15 12Z"/>
</svg>
</template>;